import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../../api/api";
import { toast } from "sonner";

/**
 * Custom hook untuk mengunduh template booking Excel.
 * Menggunakan useMutation karena ini adalah aksi yang dipicu oleh pengguna,
 * meskipun menggunakan metode GET.
 */
export const useDownloadBookingTemplate = () => {
    return useMutation({
        mutationFn: async (propertyId: string) => {
            if (!propertyId) {
                throw new Error("Property ID is required to download the template.");
            }

            // PERBAIKAN: Mengubah dari POST menjadi GET
            // Data yang sebelumnya ada di body, sekarang dipindahkan ke dalam 'params'
            return await privateApi.get('/v4/booking-template', {
                params: {
                    filter: {
                        property_id: propertyId
                    }
                },
                // Opsi untuk menerima respons sebagai file tetap ada
                responseType: 'blob'
            });
        },
        onSuccess: (response) => {
            // Logika untuk memicu unduhan di browser (tidak ada perubahan di sini)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let filename = 'booking-import-template.xlsx';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch && filenameMatch.length > 1) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success("Template downloaded successfully.");
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message || "Failed to download template.");
        }
    });
};